import { render, staticRenderFns } from "./CmsRegistTalkContact.vue?vue&type=template&id=146f8717&scoped=true&"
import script from "./CmsRegistTalkContact.vue?vue&type=script&lang=js&"
export * from "./CmsRegistTalkContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f8717",
  null
  
)

export default component.exports